// Presentational formatters for the Payments Manager.
//
// NOTE: formatFcfa currently uses native Number for formatting, matching the
// original PaymentManager.tsx behavior byte-for-byte. Display-only formatting
// never executes arithmetic, but if these helpers are ever extended to add/
// subtract amounts, migrate to decimal.js first.
// TODO(maintainability-sprint): migrate to Decimal when arithmetic is added.

export function formatFcfa(amount: number | null | undefined): string {
  const n = Number(amount);
  if (isNaN(n)) return "—";
  return `${n.toLocaleString("fr-SN")} FCFA`;
}

export function formatDate(d: string | null | undefined): string {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("fr-SN");
}

export function scoreColor(score: number): string {
  if (score >= 80) return "text-emerald-700 bg-emerald-100";
  if (score >= 60) return "text-amber-700 bg-amber-100";
  return "text-red-700 bg-red-100";
}
